(function ($, Drupal) {
  /**
   * Update consent for Google Tag
   */
  function updateConsent() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      // eslint-disable-next-line no-undef,prefer-rest-params
      dataLayer.push(arguments);
    }

    if (Drupal.eu_cookie_compliance) {
      const acceptedCategories = Drupal.eu_cookie_compliance.getAcceptedCategories();
      const analyticsAccepted = acceptedCategories.includes('analytics');
      const marketingAccepted = analyticsAccepted || acceptedCategories.includes('advertising');

      gtag('consent', 'update', {
        ad_user_data: marketingAccepted ? 'granted' : 'denied',
        ad_personalization: marketingAccepted ? 'granted' : 'denied',
        ad_storage: marketingAccepted ? 'granted' : 'denied',
        analytics_storage: analyticsAccepted ? 'granted' : 'denied',
      });
    }
  }

  Drupal.behaviors.consent = {
    attach: function () {
      once('consent', 'html').forEach(function () {
        updateConsent();

        $(document).on('eu_cookie_compliance.changePreferences', function () {
          updateConsent();
        });
      });
    },
  };
}(jQuery, Drupal));
